import { NavLink } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";
import React from "react";
import useTranslation from "../../i18n/useTranslation";

export default function StripeOnboardRetryPage() {
    const { t } = useTranslation();

    return (
        <div
            style={{
                backgroundColor: "#14151a",
                color: "#ffffff",
                fontFamily: "'Poppins', sans-serif",
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflowX: "hidden",
            }}
        >
            <div
                style={{
                    backgroundColor: "#1f1f2e",
                    borderRadius: "12px",
                    padding: "30px",
                    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.3)",
                    textAlign: "center",
                    maxWidth: "450px",
                    width: "100%",
                }}
            >
                <div className="mb-3">
                    <NavLink to="/">
                        <img
                            src="/dist/img/angeonx-sports.png"
                            alt={t("stripeOnboardRetryPage.brandAlt")}
                            className="logo img-fluid"
                            style={{ height: "80px", marginBottom: "10px" }}
                        />
                    </NavLink>

                    <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "var(--kbs-primary, #00adff)" }}>
                        kBola <span style={{ color: "#ffffff" }}>Sports</span>
                    </h2>
                </div>

                <h3 style={{ fontSize: "20px", fontWeight: "bold", color: "#ffcc00" }}>
                    {t("stripeOnboardRetryPage.title")}
                </h3>

                <p>
                    <FaExclamationTriangle size={50} color="#ffcc00" />
                </p>

                <p style={{ fontSize: "16px", fontWeight: "500", color: "#f1f2f5" }}>
                    {t("stripeOnboardRetryPage.message")}
                </p>

                <NavLink to="/dashboard">
                    <button
                        style={{
                            marginTop: "15px",
                            padding: "10px 20px",
                            backgroundColor: "var(--kbs-primary, #00adff)",
                            color: "#14151a",
                            border: "none",
                            borderRadius: "8px",
                            fontWeight: "bold",
                            cursor: "pointer",
                        }}
                    >
                        {t("stripeOnboardRetryPage.retry")}
                    </button>
                </NavLink>
            </div>
        </div>
    );
}
